var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68.738983mm",
    height: "68.354332mm",
    viewBox: "0 0 68.738983 68.354332",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-10.439759,-95.154302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4274",
    transform: "translate(-102.79899,34.052257)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.499999,
      paintOrder: "stroke fill markers"
    },
    d: "m 141.37663,61.102047 -22.38962,13.599352 -5.74826,23.199238 10.82905,24.747973 31.47351,6.80775 24.44724,-16.86899 1.98918,-27.321983 -14.72361,-20.661543 z",
    id: "path236-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2435-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.461701,
      paintOrder: "stroke fill markers"
    },
    d: "m 137.09086,73.876628 -4.06797,0.99012 -1.22887,0.887801 0.23151,11.431344 1.19114,4.904093 4.85552,5.694743 2.47427,0.910022 1.28674,8.240839 -3.15381,1.55391 -1.29553,2.60553 3.65353,0.28835 4.66069,-0.87695 4.47622,-1.2764 1.85931,-1.33119 0.12558,-1.62161 -6.29471,-0.39945 -2.55798,-7.661553 2.04587,-2.43551 1.71514,-3.583244 0.14056,-3.437516 -1.27124,-4.97489 -4.33514,-9.880017 z m 0.3054,5.444629 0.35399,0.425297 -0.076,0.45992 -0.66972,-0.105937 -0.061,-0.556555 z m 19.57245,1.22163 -1.48828,0.288872 -4.5992,10.467578 -0.98289,4.950085 2.00918,7.208858 1.86242,1.86656 -2.30012,8.01708 -3.51503,0.0832 -2.27118,1.81849 3.19309,1.79886 4.59765,1.1653 4.59766,0.72502 2.24637,-0.42581 0.79633,-1.418 -5.54229,-3.01016 0.90227,-8.02741 2.88096,-1.34824 3.06338,-2.52904 1.57354,-3.059766 0.93948,-5.047754 0.22376,-10.786939 -4.08037,-1.923913 z m -17.14262,0.564307 0.30334,0.476457 -0.35812,0.502295 -0.75706,-0.225826 0.0956,-0.653707 z m -2.33164,1.896008 0.80822,0.330729 0.27233,0.868165 -0.7059,0.605647 -0.87074,-0.262516 -0.11318,-0.829407 z m 21.56768,3.420463 0.14211,0.534851 -0.262,0.385507 -0.56328,-0.378272 0.1788,-0.530717 z m -13.95212,0.578776 0.32814,1.882056 0.11162,2.942973 -2.05879,4.067452 -4.12326,0.910539 -4.46278,-5.05809 -0.78289,-3.276285 1.65829,-0.526066 2.6417,-0.460954 3.49591,-0.294039 z m 14.71331,1.852601 0.69143,0.210839 0.0749,0.560173 -0.5364,0.304891 -0.5917,-0.522966 z m -2.22105,0.950329 0.59428,0.640271 -0.11834,0.901754 -0.89504,0.252698 -0.68006,-0.604615 0.2465,-0.799951 z m -5.3604,3.541903 1.72599,0.220141 2.59054,0.693498 3.29541,1.203544 2.97501,1.173055 -0.49454,1.845366 -1.13688,2.716632 -3.5786,2.82411 -4.12378,-0.90847 -1.92081,-6.466269 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaTwo);
export default __webpack_public_path__ + "static/media/Area_two.e36d7c0486257d4b4c78b852576814ce.svg";
export { ForwardRef as ReactComponent };